import React from 'react';
import { motion } from 'framer-motion';
import { allSlots } from '../data/calendar';
import { channelLoad } from '../utils/stats';
export function ChannelLoad() {
  const rows = channelLoad(allSlots);
  const max = Math.max(...rows.map(r => r.count));
  return <ul className="space-y-3" data-id="element-43" data-mp="llyemmsxs887">
      {rows.map((row, i) => <li key={row.label} data-id="element-44" data-mp="po1qvdnfjguj" data-mpi={i}>
          <div className="flex items-baseline justify-between gap-3" data-id="element-45" data-mp="pn9z6dwye39j">
            <span className="text-[13px] text-chalk" data-id="element-46" data-mp="bo0fv5dgat1c">{row.label}</span>
            <span className="font-mono text-[11px] text-mute" data-id="element-47" data-mp="goy86as6d3gk">{row.count}</span>
          </div>
          <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-ink-800" data-id="element-48" data-mp="2pf4bu6ecea2">
            <motion.span initial={{
          width: 0
        }} animate={{
          width: `${row.count / max * 100}%`
        }} transition={{
          duration: 0.6,
          delay: i * 0.05,
          ease: [0.22, 1, 0.36, 1]
        }} className="block h-full rounded-full bg-productc/80" data-id="element-49" data-mp="6q8s8nju9t2y" />
          </div>
        </li>)}
    </ul>;
}